/**
 * Date-extensions locale Talossan [tzl]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('tzl', {
    monthNames: ['Januar','Fevraglh','Març','Avrïu','Mai','Gün','Julia','Guscht','Setemvar','Listopäts','Noemvar','Zecemvar'],
    monthShortNames: ['Jan','Fev','Mar','Avr','Mai','Gün','Jul','Gus','Set','Lis','Noe','Zec'],
    dayNames: ['Súladi','Lúneçi','Maitzi','Márcuri','Xhúadi','Viénerçi','Sáturi'],
    dayShortNames: ['Súl','Lún','Mai','Már','Xhú','Vié','Sát']
});
